import React, { useEffect, useRef } from "react";
import "./custom-headline.module.css";

export const CustomHeadline = ({ headline, editData, onEdit = () => {}, id }) => {
  const headlineRef = useRef(null);
  const phoneNuberValue = `<div class="edit-wrapper"><span>${editData}</span><span id=${id}><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.7774 2.46658L15.5324 4.22158C15.8249 4.51408 15.8249 4.98658 15.5324 5.27908L14.1599 6.65159L11.3474 3.83908L12.7199 2.46658C12.8624 2.32408 13.0499 2.24908 13.2449 2.24908C13.4399 2.24908 13.6274 2.31658 13.7774 2.46658ZM2.24994 12.9366V15.7491H5.06244L13.3574 7.45406L10.5449 4.64156L2.24994 12.9366ZM4.43992 14.2489H3.74992V13.5589L10.5449 6.76389L11.2349 7.45389L4.43992 14.2489Z" fill="currentColor" /></svg></span></div>`;
  const emailValue = `<div class="edit-wrapper"><span>${editData}</span><span id=${id}><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.7774 2.46658L15.5324 4.22158C15.8249 4.51408 15.8249 4.98658 15.5324 5.27908L14.1599 6.65159L11.3474 3.83908L12.7199 2.46658C12.8624 2.32408 13.0499 2.24908 13.2449 2.24908C13.4399 2.24908 13.6274 2.31658 13.7774 2.46658ZM2.24994 12.9366V15.7491H5.06244L13.3574 7.45406L10.5449 4.64156L2.24994 12.9366ZM4.43992 14.2489H3.74992V13.5589L10.5449 6.76389L11.2349 7.45389L4.43992 14.2489Z" fill="currentColor" /></svg></span></div>`;

  useEffect(() => {
    const headlineElement = headlineRef.current;
    if (headlineElement) {
      const editElement = headlineElement.querySelector(`#${id}`);
      if (editElement) {
        editElement.addEventListener("click", () => onEdit());
        return () => {
          editElement.removeEventListener("click", () => onEdit());
        };
      }
    }
  }, [headlineRef, id]);

  const shortCodeMapping = [
    { code: "[phone-number]", value: phoneNuberValue },
    { code: "[email]", value: emailValue },
  ];

  let updatedHeadline = headline;
  shortCodeMapping.forEach((item) => {
    updatedHeadline = updatedHeadline.replace(item.code, item.value);
  });

  return (
    <div
      ref={headlineRef}
      styleName={editData ? "wrapper custom-style" : "wrapper"}
      dangerouslySetInnerHTML={{ __html: updatedHeadline }}
    />
  );
};
